import script from "./SensorStatusCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensorStatusCard.vue?vue&type=script&setup=true&lang=ts"

import "./SensorStatusCard.vue?vue&type=style&index=0&id=4bd96b83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd96b83"]])

export default __exports__